import React, { useState, useEffect } from 'react'
import FetchApi from '../../customhooks/functionFetchApi';
import DataTable from 'react-data-table-component';
import { columns, headersexcel } from './prepasscomponent/columns';
import { Button } from 'react-bootstrap';
import { CSVLink, CSVDownload } from "react-csv";
import { ImFileExcel } from "react-icons/im";
import XLSX from "xlsx";
import Moment from 'moment';
import Swal from 'sweetalert2';

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};


const Searchlistprepress = () => {
    const d = new Date();
    let datenow = d.getDate() + '-' + d.getMonth() + '-' + d.getFullYear();
    const FetchApis = new FetchApi();
    const DepartId = sessionStorage.getItem('DepartId');
    const [dataJournal, setDatajournal] = useState([]);

    const [datejournal, setDatejournal] = useState({ DepartmentId: "DepartId", StartDate: "", EndDate: "" });

    useEffect(() => {

    }, [])

    // DepartmentId,StartDate,EndDate 
    function isSearchList() {

        let dt = {
            DepartmentId: DepartId,
            StartDate: Moment(datejournal.StartDate).format('YYYY-MM-DD'),
            EndDate: Moment(datejournal.EndDate).format('YYYY-MM-DD')
        }

        FetchApis.FethcPost(`/reportjournal/getreportjournalapprovedtotal`, dt).then(res => {
            if (res) {
                setDatajournal(res.data)
                if (res.data.length == 0) {
                    Swal.fire({
                        title: "แจ้งเตือน!",
                        text: "ไม่พบข้อมูลในการ ค้นหา",
                        icon: "warning"
                    });
                }
            }
        })
    }




    return (
        <div>
            <div style={{ flexDirection: 'row', display: 'flex', marginBottom: 10, backgroundColor: '#EBEBEB', padding: 10 }}>

                <div style={{ margin: 5 }}>
                    <label>วันที่เริ่ม</label>
                    <input type='date'
                        value={datejournal.dateStart}
                        onChange={(e) => setDatejournal({ ...datejournal, StartDate: e.target.value })} />
                </div>

                <div style={{ margin: 5 }}>
                    <label>ถึงวันที่</label>
                    <input type='date'
                        value={datejournal.EndDate}
                        onChange={(e) => setDatejournal({ ...datejournal, EndDate: e.target.value })} />
                </div>
                <div>
                    <Button onClick={() => isSearchList()}>ค้นหา</Button>
                </div>

            </div>
            <div>
                <div style={{ flexDirection: 'row', justifyContent: 'flex-end', display: 'flex' }}>
                    {dataJournal.length > 0 &&
                        <CSVLink data={dataJournal} headers={headersexcel} filename={`journal-report${datenow}.csv`}>
                            <ImFileExcel size={25} />
                            <label>download</label>
                        </CSVLink>}

                </div>

                <DataTable
                    columns={columns}
                    data={dataJournal}
                    // selectableRows
                    pagination
                    customStyles={customStyles}
                    highlightOnHover
                />
            </div>
        </div>
    )
}

export default Searchlistprepress